export default "__VITE_ASSET__CxZY5$wy__"